import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { StorageKeys } from '@/services/storage';
import { logout } from '@/slices/authSlice';

export const useLogoutListener = (): void => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent): void => {
      if (event.key === StorageKeys.GxToken && !event.newValue) {
        dispatch(logout());
        navigate('/login');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch, navigate]);
};
